<template>
  <div>
    <div v-show="isEditing">
      <div class="title">
        <i class="iconfont icon-back" @click="goback()"></i>
        <img src="/static/logo.png" />
        <div>{{ title }}</div>
      </div>
      <div
        class="weui-cells weui-cells_form"
        id="uploader"
        style="margin-top: 0px"
      >
        <a
          class="weui-cell weui-cell_access"
          href="javascript:;"
          v-if="circle.goodsType == 10"
          @click="showMajorPicker"
        >
          <div class="weui-cell__bd">
            <label class="weui-label" style="width: 54px">院系：</label>
          </div>
          <div class="weui-cell__ft">
            {{ circle.major ? circle.major : "请选择适用的院系" }}
          </div>
        </a>
        <a
          class="weui-cell weui-cell_access"
          href="javascript:;"
          v-if="circle.goodsType == 10"
          @click="showClassPicker"
        >
          <div class="weui-cell__bd">
            <label class="weui-label" style="width: 54px">年级：</label>
          </div>
          <div class="weui-cell__ft">
            {{ circle.class ? circle.class : "请选择适用的年级" }}
          </div>
        </a>
        <a
          class="weui-cell weui-cell_access"
          href="javascript:;"
          v-if="circle.goodsType != 10 && circle.bizType != 70"
          @click="showCategoryPicker"
        >
          <div class="weui-cell__bd">
            <label class="weui-label" style="width: 54px">分类：</label>
          </div>
          <div class="weui-cell__ft">
            {{ currGoodsType.text ? currGoodsType.text : "请选物品类别" }}
          </div>
        </a>
        <a
          class="weui-cell weui-cell_access"
          href="javascript:;"
          v-if="circle.bizType == 20"
          @click="showLevelPicker"
        >
          <div class="weui-cell__bd">
            <label class="weui-label" style="width: 54px">成色：</label>
          </div>
          <div class="weui-cell__ft">
            {{ currLevel.text ? currLevel.text : "请选择物品成色" }}
          </div>
        </a>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label class="weui-label" style="width: 54px"
              >{{ typeTitle }}：</label
            >
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              v-model="circle.title"
              oninput="if(value.length>32)value=value.slice(0,32)"
              :placeholder="placeholder"
            />
          </div>
        </div>
        <div class="weui-cell" v-if="circle.bizType != 70">
          <div class="weui-cell__hd">
            <label class="weui-label" style="width: 54px">数量：</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              v-model="circle.sum"
              type="number"
              oninput="if(value.length>18)value=value.slice(0,18)"
              placeholder="请输入数量"
            />
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__bd">
            <textarea
              class="weui-textarea"
              v-model="circle.remark"
              maxlength="100"
              placeholder="详细描述（选填）"
              rows="2"
            ></textarea>
            <div
              class="weui-textarea-counter"
              :class="{
                'text-error': circle.remark && circle.remark.length > 100,
              }"
            >
              <span>{{ circle.remark ? circle.remark.length : 0 }}</span
              >/100
            </div>
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__bd">
            <div class="weui-uploader">
              <div class="weui-uploader__hd">
                <p class="weui-uploader__title">
                  请上图片
                  <span style="color: red">（单张不能超过4M）</span>
                </p>
                <div class="weui-uploader__info">
                  <span>{{ uploadCount }}</span
                  >/9
                </div>
              </div>
              <div class="weui-uploader__bd">
                <ul class="weui-uploader__files" id="uploaderFiles">
                  <li
                    class="weui-uploader__file"
                    :data-id="item._id"
                    v-for="item in picsForEdit"
                    :key="item._id"
                    :style="'background-image:url(' + item.url + ')'"
                  ></li>
                </ul>
                <div class="weui-uploader__input-box">
                  <input
                    id="uploaderInput"
                    class="weui-uploader__input"
                    type="file"
                    accept="image/*"
                    multiple
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="weui-cell"
          v-if="circle.bizType != 50 && circle.bizType != 60"
        >
          <div
            class="pay"
            :class="circle.feeType == 1 ? 'gou-selected' : 'gou-unselect'"
            @click="fee(1)"
          >
            <i class="iconfont icon-gou"></i> 出个友情价格
          </div>
          <div
            class="free"
            :class="circle.feeType == 2 ? 'gou-selected' : 'gou-unselect'"
            @click="fee(2)"
          >
            <i class="iconfont icon-gou"></i>
            {{ feeTitle }}
          </div>
        </div>
        <div
          class="weui-cell"
          v-if="
            circle.bizType != 50 && circle.bizType != 60 && circle.feeType == 1
          "
        >
          <div class="weui-cell__hd">
            <label class="weui-label" style="width: 54px">单价：</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              v-model="circle.price"
              type="number"
              oninput="if(value.length>18)value=value.slice(0,18)"
              placeholder="请输入单价（单位：元）"
            />
          </div>
        </div>
        <div
          class="weui-cell"
          v-if="
            circle.feeType == 1 &&
            showCost &&
            (circle.bizType == 20 || circle.bizType == 40)
          "
        >
          <div class="weui-cell__hd">
            <label class="weui-label" style="width: 54px">原价：</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              v-model="circle.cost"
              type="number"
              oninput="if(value.length>18)value=value.slice(0,18)"
              placeholder="请输入原价（单位：元）"
            />
          </div>
        </div>
        <div
          class="weui-cell"
          v-if="
            circle.feeType == 2 &&
            (circle.bizType == 20 ||
              circle.bizType == 40 ||
              circle.bizType == 70)
          "
        >
          <div class="weui-cell__hd">
            <label class="weui-label" style="width: 54px">要求：</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              v-model="circle.demand"
              maxlength="20"
              placeholder="如果有，请注明（不超过20个字）"
            />
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label class="weui-label" style="width: 72px">手机号：</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              v-model="circle.phone"
              oninput="if(value.length>11)value=value.slice(0,11)"
              placeholder="请输入您的手机号码"
            />
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label class="weui-label" style="width: 72px">微信号：</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              v-model="circle.wxNo"
              maxlength="20"
              placeholder="请输入您的微信号"
            />
          </div>
        </div>
      </div>
      <div
        class="warehousing-footer-item sureinwarehousing"
        style="flex: 2"
        @click="save"
      >
        <a href="javascript:;">提 交</a>
      </div>
    </div>
    <div v-show="!isEditing">
      <div class="result-content" v-if="creatingShareImg">
        <div id="result">
          <img class="logo" src="/static/print.png" />
          <div class="result-cover">
            <img :src="resultCover" style="width: 160px" />
          </div>
          <div class="result-title">
            <div>
              【{{ typeTitle }}】{{ currLevel.text ? currLevel.text : ""
              }}{{ circle.title }}
            </div>
          </div>
          <div
            class="result-demand"
            v-if="circle.bizType != 50 && circle.bizType != 60"
          >
            {{ resultDemand }}
          </div>
          <div class="result-qrcode">
            <canvas id="qrCanvas"></canvas>
          </div>
          <div class="result-qr-tips">长按识别二维码查看详情</div>
        </div>
      </div>
      <div class="result-content" v-else>
        <img class="share-img" :src="downloadBase64" />
      </div>
      <div class="weui-msg result-tips" style="padding-top: 5px">
        <div class="weui-msg__text-area">
          <h2 class="weui-msg__title" style="color: #1aad19; font-weight: bold">
            发布成功
          </h2>
          <p class="weui-msg__desc" style="color: #fda800">
            分享：您可以长按保存图片至手机相册再分享到朋友圈，也可以直接点击微信右上角直接分享到朋友圈。
          </p>
        </div>
        <div class="weui-msg__opr-area">
          <p class="weui-btn-area">
            <a
              href="javascript:;"
              class="weui-btn weui-btn_default"
              @click="gotoDetail"
              >查看详情</a
            >
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const wx = require("weixin-js-sdk");
import QRCode from "qrcode";
import html2canvas from "html2canvas";
import weui from "weui.js";
import axios from "axios";
import config from "../../config/config.js";

export default {
  data() {
    return {
      encodeToken: null,
      token: null,
      isEditing: true,
      clientWidth: null,
      resultCover: "",
      resultDemand: "",
      userInfo: {},
      currGoodsType: {},
      title: "",
      typeTitle: "",
      placeholder: "",
      feeTitle: "",
      showCost: false,
      uploadCount: 0,
      uploadList: [],
      currBlobUrl: "",
      circle: {
        bizType: null,
        goodsType: null,
        feeType: 1,
        sum: 1,
        show: 1,
        major: "",
        class: "",
        level: null,
        pics: [],
      },
      picsForEdit: [],
      categoryPicker: null,
      categorys: [
        { text: "日常用品", value: 20 },
        { text: "数码", value: 30 },
        { text: "穿戴", value: 40 },
        { text: "代步", value: 50 },
        { text: "文体", value: 60 },
        { text: "其他", value: 70 },
      ],
      categorySelectedIndex: 0,
      majorPicker: null,
      classPicker: null,
      class: [
        { text: "适用所有年级", value: 0 },
        { text: "大一", value: 1 },
        { text: "大二", value: 2 },
        { text: "大三", value: 3 },
        { text: "大四", value: 4 },
        { text: "考研", value: 5 },
        { text: "公务员", value: 6 },
        { text: "硕士", value: 7 },
        { text: "博士", value: 8 },
        { text: "出国", value: 9 },
        { text: "其他", value: 10 },
      ],
      classSelectedIndex: 0,
      majors: [],
      majorSelectedIndex: 0,
      levelPicker: null,
      levels: [
        { text: "全新", value: 100 },
        { text: "99新", value: 99 },
        { text: "九成新", value: 90 },
        { text: "八成新", value: 80 },
        { text: "七成新", value: 70 },
        { text: "六成新", value: 60 },
        { text: "五成新", value: 50 },
        { text: "四成新", value: 40 },
        { text: "三成新", value: 30 },
        { text: "二成新", value: 20 },
        { text: "一成新", value: 10 },
      ],
      levelSelectedIndex: 0,
      currLevel: {},
      downloadBase64: null,
      creatingShareImg: true,
    };
  },
  created() {
    this.encodeToken = this.$route.params.token;
    this.token = decodeURIComponent(this.encodeToken);
    axios.defaults.headers["Authorization"] = "Bearer " + this.token;
    this.circle.bizType = this.$route.params.bizType;
    this.circle.goodsType = this.$route.params.goodsType;

    if (this.$route.params.id != "-1") {
      let _id = this.$route.params.id;
      // 获取详情
      axios
        .get("/api/circle/detail/" + _id)
        .then((res) => {
          if (res.data.success) {
            this.circle = res.data.data;
            this.picsForEdit = JSON.parse(JSON.stringify(this.circle.pics));
            this.uploadList = JSON.parse(JSON.stringify(this.circle.pics));
            this.uploadCount = this.uploadList.length;
            if (this.circle.goodsType == 10) {
              //书籍，需要初始适用院系和年级
              for (let i = 0; i < this.majors.length; i++) {
                if (this.majors[i].text == this.circle.major) {
                  this.majorSelectedIndex = i;
                  break;
                }
              }

              for (let i = 0; i < this.class.length; i++) {
                if (this.class[i].text == this.circle.class) {
                  this.classSelectedIndex = i;
                  break;
                }
              }

              for (let i = 0; i < this.levels.length; i++) {
                if (this.levels[i].value == this.circle.level) {
                  this.levelSelectedIndex = i;
                  this.currLevel = this.levels[i];
                  break;
                }
              }
            } else if (
              this.circle.goodsType != 10 &&
              this.circle.bizType != 70
            ) {
              for (let i = 0; i < this.categorys.length; i++) {
                if (this.circle.goodsType == this.categorys[i].value) {
                  this.currGoodsType = this.categorys[i];
                  this.categorySelectedIndex = i;
                  break;
                }
              }
            }
          } else {
            weui.alert("获取详情失败");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
    this.clientWidth = document.body.clientWidth;

    if (this.circle.bizType == 10) {
      if (this.circle.goodsType == 10) {
        this.title = "想省钱买书";
        this.placeholder = "如高等数据、大学英语等";
        this.resultCover = "/static/gt-2-200x200.png";
      } else {
        this.title = "想省钱买";
        this.placeholder = "请输入物品名称";
        this.resultCover = "/static/gt-4-200x200.png";
      }
      this.typeTitle = "想买";
      this.feeTitle = "价格线下商量";
      this.showCost = true;
    } else if (this.circle.bizType == 20) {
      if (this.circle.goodsType == 10) {
        this.title = "出售闲置书籍";
        this.placeholder = "如高等数据、大学英语等";
        this.resultCover = "/static/gt-1-200x200.png";
      } else {
        this.title = "出售闲置物品";
        this.placeholder = "请输入物品名称";
        this.resultCover = "/static/gt-3-200x200.png";
      }
      this.typeTitle = "出售";
      this.feeTitle = "免费送有缘人";
      this.showCost = true;
    } else if (this.circle.bizType == 30) {
      this.title = "想租物品";
      this.placeholder = "请输入物品名称";
      this.feeTitle = "价格线下商量";
      this.typeTitle = "想租";
      this.resultCover = "/static/gt-5-200x200.png";
    } else if (this.circle.bizType == 40) {
      this.title = "出租闲置物品";
      this.placeholder = "请输入物品名称";
      this.feeTitle = "不要钱拿去用";
      this.typeTitle = "出租";
      this.resultCover = "/static/gt-6-200x200.png";
    } else if (this.circle.bizType == 50) {
      this.title = "想借物品";
      this.placeholder = "请输入物品名称";
      this.typeTitle = "想借";
      this.resultCover = "/static/gt-7-200x200.png";
      this.circle.feeType = 2;
    } else if (this.circle.bizType == 60) {
      this.title = "出借闲置物品";
      this.placeholder = "请输入物品名称";
      this.typeTitle = "出借";
      this.resultCover = "/static/gt-8-200x200.png";
      this.circle.feeType = 2;
    } else if (this.circle.bizType == 70) {
      this.title = "技能服务";
      this.placeholder = "如修电脑、吉他教学等";
      this.feeTitle = "我有其他要求";
      this.typeTitle = "我能";
      this.resultCover = "/static/gt-9-200x200.png";
      this.circle.sum = -1;
    }

    if (
      !this.$store.state.User ||
      !this.$store.state.User.userInfo ||
      !this.$store.state.User.userInfo._id
    ) {
      axios
        .get("/api/user/wxuserInfo")
        .then((res) => {
          if (res.data.success) {
            this.userInfo = res.data.data;
            this.circle.phone = this.userInfo.phoneMain;
            this.circle.wxNo = this.userInfo.wxNo;
            this.$store.commit("User/add", res.data.data);

            this.majors = [{ text: "适用所有院系", value: 0 }];
            let temp = this.userInfo.worksite.majors;
            for (let i = 0; i < temp.length; i++) {
              this.majors.push({
                text: temp[i],
                value: i + 1,
              });
            }
          } else {
            weui.alert("获取用户信息失败");
          }
        })
        .catch((err) => {
          weui.alert("获取用户信息失败");
        });
    } else {
      this.userInfo = this.$store.state.User.userInfo;
      this.majors = [{ text: "适用所有院系", value: 0 }];
      let temp = this.userInfo.worksite.majors;
      for (let i = 0; i < temp.length; i++) {
        this.majors.push({
          text: temp[i],
          value: i + 1,
        });
      }
      if (!this.circle._id) {
        this.circle.phone = this.userInfo.phoneMain;
        this.circle.wxNo = this.userInfo.wxNo;
      }
    }
  },
  mounted() {
    let that = this;
    /* 图片自动上传 */
    weui.uploader("#uploader", {
      url: "/api/upload/uploadFile",
      auto: true,
      type: "file",
      fileVal: "fileVal",
      compress: {
        width: 1600,
        height: 1600,
        quality: 0.8,
      },
      onBeforeQueued: function (files) {
        if (
          ["image/jpg", "image/jpeg", "image/png", "image/gif"].indexOf(
            this.type
          ) < 0
        ) {
          weui.alert("请上传正确格式的图片（jpg/png/gif）");
          return false;
        }
        if (this.size > 4 * 1024 * 1024) {
          weui.alert("请上传不超过4M的图片");
          return false;
        }
        if (files.length > 9) {
          // 防止一下子选中过多文件
          weui.alert("最多只能上传9张图片");
          return false;
        }
        if (that.uploadCount + 1 > 9) {
          weui.alert("最多只能上传9张图片");
          return false;
        }

        that.uploadCount++;
      },
      onQueued: function () {
        that.uploadList.push(this);
        that.currBlobUrl = this.url;
      },
      onBeforeSend: function (data, headers) {
        headers["Authorization"] = "Bearer " + that.token;
        data.blobUrl = that.currBlobUrl;
      },
      onProgress: function (procent) {},
      onSuccess: function (ret) {
        let picUrl = `${config.xytPreUrl}/sign/${ret.data.dateFolder}/${ret.data.destFileName}`;
        that.circle.pics.push({
          _id: ret.data._id,
          blobUrl: ret.blobUrl,
          url: picUrl,
        });
      },
      onError: function (err) {
        console.log(err);
      },
    });

    // 图片点击
    document
      .querySelector("#uploaderFiles")
      .addEventListener("click", function (e) {
        var target = e.target;

        while (!target.classList.contains("weui-uploader__file") && target) {
          target = target.parentNode;
        }
        if (!target) return;

        var url = target.getAttribute("style") || "";
        var id = target.getAttribute("data-id");

        if (url) {
          url = url.match(/url\((.*?)\)/)[1].replace(/"/g, "");
        }
        var gallery = weui.gallery(url, {
          className: "custom-name",
          onDelete: function () {
            weui.confirm("确定删除该图片？", function () {
              that.uploadCount--;
              (function () {
                for (var i = 0, len = that.uploadList.length; i < len; ++i) {
                  var file = that.uploadList[i];
                  if (id && file._id && file._id == id) {
                    if (file.id) {
                      file.stop();
                    }
                    that.uploadList.splice(i, 1);

                    // 删除pics数据
                    for (let j = 0; j < that.circle.pics.length; j++) {
                      if (
                        file.url == that.circle.pics[j].blobUrl ||
                        file.blobUrl == that.circle.pics[j].blobUrl
                      ) {
                        that.circle.pics.splice(j, 1);
                        return;
                      }
                    }
                  }
                }
              })();
              target.remove();
              gallery.hide();
            });
          },
        });
      });
  },
  methods: {
    goback() {
      this.$router.back(-1);
    },
    fee(type) {
      this.circle.feeType = type;
      if (type == 1) {
        this.circle.demand = null;
      } else {
        this.circle.price = null;
        this.circle.cost = null;
      }
    },
    showMajorPicker() {
      if (!this.majorPicker) {
        this.majorPicker = this.$createPicker({
          title: "院系选择",
          data: [this.majors],
          selectedIndex: [this.majorSelectedIndex],
          onSelect: this.selectMajorHandle,
        });
      }
      this.majorPicker.show();
    },
    selectMajorHandle(selectedVal, selectedIndex, selectedText) {
      this.circle.major = selectedText[0];
    },
    showClassPicker() {
      if (!this.classPicker) {
        this.classPicker = this.$createPicker({
          title: "年级选择",
          data: [this.class],
          selectedIndex: [this.classSelectedIndex],
          onSelect: this.selectClassHandle,
        });
      }
      this.classPicker.show();
    },
    selectClassHandle(selectedVal, selectedIndex, selectedText) {
      this.circle.class = selectedText[0];
    },
    showCategoryPicker() {
      if (!this.categoryPicker) {
        this.categoryPicker = this.$createPicker({
          title: "类别选择",
          data: [this.categorys],
          selectedIndex: [this.categorySelectedIndex],
          onSelect: this.selectCategoryHandle,
        });
      }
      this.categoryPicker.show();
    },
    selectCategoryHandle(selectedVal, selectedIndex, selectedText) {
      this.currGoodsType = this.categorys[selectedIndex];
      this.circle.goodsType = selectedVal[0];
    },
    showLevelPicker() {
      if (!this.levelPicker) {
        this.levelPicker = this.$createPicker({
          title: "成色选择",
          data: [this.levels],
          selectedIndex: [this.levelSelectedIndex],
          onSelect: this.selectLevelHandle,
        });
      }
      this.levelPicker.show();
    },
    selectLevelHandle(selectedVal, selectedIndex, selectedText) {
      this.currLevel = this.levels[selectedIndex];
      this.circle.level = selectedVal[0];
    },
    save() {
      if (!this.circle._id) {
        this.add();
      } else {
        this.update();
      }
    },
    add() {
      let checkStatus = this.checkData();
      if (checkStatus) {
        this.circle.worksite = this.userInfo.worksite._id;
        axios
          .post("/api/circle/add", this.circle)
          .then((res) => {
            if (res.data.success) {
              this.isEditing = false;
              this.circle._id = res.data.data;

              // 生成二维码链接
              this.createQrcode();
            } else {
              weui.alert("提交失败");
            }
          })
          .catch((err) => {
            weui.alert("提交失败");
          });
      }
    },
    update() {
      let checkStatus = this.checkData();
      if (checkStatus) {
        axios
          .put("/api/circle/edit", this.circle)
          .then((res) => {
            if (res.data.success) {
              this.isEditing = false;

              // 生成二维码链接
              this.createQrcode();
            } else {
              weui.alert("提交失败");
            }
          })
          .catch((err) => {
            weui.alert("提交失败");
          });
      }
    },
    createQrcode() {
      let that = this;
      /* 初始化微信分享 */
      let level = this.currLevel.text ? this.currLevel.text : "";
      let shareTitle = "本喵" + this.typeTitle + level + this.circle.title; // 分享标题
      let shareDesc =
        '本喵分享了最新动态，精彩校园生活尽在"校圆通"，快进来看看TAヾ(≧O≦)〃喵~'; // 分享描述
      let shareLink =
        "http://wx.aixyt.com/#/share/circleDetail/" + this.circle._id;
      let shareLogo = "";

      if (this.circle.bizType == 10) {
        if (this.circle.goodsType == 10) {
          shareLogo = "http://static.aixyt.com/circle-10-10.png";
        } else {
          shareLogo = "http://static.aixyt.com/circle-10.png";
        }
      } else if (this.circle.bizType == 20) {
        if (this.circle.goodsType == 10) {
          shareLogo = "http://static.aixyt.com/circle-20-10.png";
        } else {
          shareLogo = "http://static.aixyt.com/circle-20.png";
        }
      } else if (this.circle.bizType == 30) {
        shareLogo = "http://static.aixyt.com/circle-30.png";
      } else if (this.circle.bizType == 40) {
        shareLogo = "http://static.aixyt.com/circle-40.png";
      } else if (this.circle.bizType == 50) {
        shareLogo = "http://static.aixyt.com/circle-50.png";
      } else if (this.circle.bizType == 60) {
        shareLogo = "http://static.aixyt.com/circle-60.png";
      } else if (this.circle.bizType == 70) {
        shareLogo = "http://static.aixyt.com/circle-70.png";
      }

      let msgShareContent = {
        title: shareTitle, // 分享标题
        desc: shareDesc, // 分享描述
        link: shareLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: shareLogo, // 分享图标
        success: () => {
          // 设置成功
        },
      };
      let tlShareContent = {
        title: shareTitle, // 分享标题
        link: shareLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: shareLogo, // 分享图标
        success: () => {
          // 设置成功
        },
      };
      let url = window.location.href;
      let params = {
        url: url,
      };
      let jsConfig = {};
      axios
        .get("/api/wx/jsconfig", { params })
        .then((res) => {
          jsConfig = res.data.data;
          jsConfig.jsApiList = [
            "updateAppMessageShareData",
            "updateTimelineShareData",
            "onMenuShareAppMessage",
            "onMenuShareTimeline",
          ];
          wx.config(jsConfig);
        })
        .catch((err) => {
          console.log(err);
        });

      wx.ready(function () {
        wx.updateAppMessageShareData(msgShareContent);
        wx.updateTimelineShareData(tlShareContent);
        wx.onMenuShareAppMessage(msgShareContent);
        wx.onMenuShareTimeline(tlShareContent);
      });

      /* 微信分享初始结束 */

      let loading = weui.loading("图片生成ing...", {
        className: "custom-classname",
      });
      let canvas = document.getElementById("qrCanvas");
      let qrContent =
        "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa5520eff0ecff405&redirect_uri=http%3A%2F%2Fwx.aixyt.com%2Fapi%2Fwx%2Fauth&response_type=code&scope=snsapi_userinfo&state=circleDetail-" +
        this.circle._id +
        "#wechat_redirect";

      // 长链接转短链接接口
      axios
        .get("/api/wxCommon/shorturl", { params: { longUrl: qrContent } })
        .then((res) => {
          if (res.data.success) {
            qrContent = res.data.data;
          }
          QRCode.toCanvas(canvas, qrContent, function (error) {
            if (error) {
              weui.alert(error);
            } else {
              setTimeout(() => {
                // 转base64
                html2canvas(document.getElementById("result")).then(function (
                  canvas
                ) {
                  that.downloadBase64 = canvas.toDataURL();
                  that.creatingShareImg = false;
                  loading.hide(function () {});
                });
              }, 200);
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    checkData() {
      if (this.circle.bizType == 10) {
        // 想买
        if (this.circle.goodsType == 10) {
          // 买书
          if (!this.circle.major) {
            weui.alert("请选择适用的院系");
            return false;
          } else if (!this.circle.class) {
            weui.alert("请选择适用的年级");
            return false;
          } else if (!this.circle.title) {
            weui.alert("请输入想买的书籍");
            return false;
          } else if (!this.circle.sum) {
            weui.alert("请输入想买的数量");
            return false;
          } else if (
            this.circle.feeType == 1 &&
            (!this.circle.price || parseFloat(this.circle.price) < 0)
          ) {
            weui.alert("友情价必填且>=0");
            return false;
          } else if (!this.circle.phone && !this.circle.wxNo) {
            weui.alert("请输入您的手机号码或微信号");
            return false;
          } else if (this.circle.phone && this.circle.phone.length != 11) {
            weui.alert("请输入正确手机号码");
            return false;
          } else {
            if (this.circle.feeType == 1) {
              this.resultDemand = "单价：￥" + this.circle.price;
            } else {
              this.circle.price = -1;
              this.resultDemand = "价格：免费";
              if (this.circle.demand) {
                this.resultDemand =
                  this.resultDemand + "，要求：" + this.circle.demand;
              }
            }
            return true;
          }
        } else {
          if (this.circle.goodsType == -1) {
            weui.alert("请选择物品类别");
            return false;
          } else if (!this.circle.title) {
            weui.alert("请输入想买的物品");
            return false;
          } else if (!this.circle.sum) {
            weui.alert("请输入想买的数量");
            return false;
          } else if (
            this.circle.feeType == 1 &&
            (!this.circle.price || parseFloat(this.circle.price) < 0)
          ) {
            weui.alert("友情价必填且>=0");
            return false;
          } else if (!this.circle.phone && !this.circle.wxNo) {
            weui.alert("请输入您的手机号码或微信号");
            return false;
          } else if (this.circle.phone && this.circle.phone.length != 11) {
            weui.alert("请输入正确手机号码");
            return false;
          } else {
            if (this.circle.feeType == 1) {
              this.resultDemand = "单价：￥" + this.circle.price;
            } else {
              this.circle.price = -1;
              this.resultDemand = "价格：免费";
              if (this.circle.demand) {
                this.resultDemand =
                  this.resultDemand + "，要求：" + this.circle.demand;
              }
            }
            return true;
          }
        }
      } else if (this.circle.bizType == 20) {
        // 出售
        if (this.circle.goodsType == 10) {
          // 售书
          if (!this.circle.major) {
            weui.alert("请选择适用的院系");
            return false;
          } else if (!this.circle.class) {
            weui.alert("请选择适用的年级");
            return false;
          } else if (!this.circle.level) {
            weui.alert("请选择书籍成色");
            return false;
          } else if (!this.circle.title) {
            weui.alert("请输入出售的书籍");
            return false;
          } else if (!this.circle.sum) {
            weui.alert("请输入数量");
            return false;
          } else if (this.circle.pics.length == 0) {
            weui.alert("请至少上传一张图片");
            return false;
          } else if (
            this.circle.feeType == 1 &&
            (!this.circle.price || !this.circle.cost)
          ) {
            weui.alert("请输入售价和原价");
            return false;
          } else if (
            this.circle.feeType == 1 &&
            (!this.circle.price || parseFloat(this.circle.price) < 0)
          ) {
            weui.alert("友情价必填且>=0");
            return false;
          } else if (this.circle.cost && parseInt(this.circle.cost) < 0) {
            weui.alert("原价必须>=0");
            return false;
          } else if (!this.circle.phone && !this.circle.wxNo) {
            weui.alert("请输入您的手机号码或微信号");
            return false;
          } else if (this.circle.phone && this.circle.phone.length != 11) {
            weui.alert("请输入正确手机号码");
            return false;
          } else {
            if (this.circle.feeType == 1) {
              this.resultDemand = "单价：￥" + this.circle.price;
            } else {
              this.circle.price = -1;
              this.resultDemand = "价格：免费";
              if (this.circle.demand) {
                this.resultDemand =
                  this.resultDemand + "，要求：" + this.circle.demand;
              }
            }
            return true;
          }
        } else {
          if (this.circle.goodsType == -1) {
            weui.alert("请选择物品类别");
            return false;
          } else if (!this.circle.level) {
            weui.alert("请选择物品成色");
            return false;
          } else if (!this.circle.title) {
            weui.alert("请输入出售的物品");
            return false;
          } else if (!this.circle.sum) {
            weui.alert("请输入数量");
            return false;
          } else if (this.circle.pics.length == 0) {
            weui.alert("请至少上传一张图片");
            return false;
          } else if (
            this.circle.feeType == 1 &&
            (!this.circle.price || !this.circle.cost)
          ) {
            weui.alert("请输入售价和原价");
            return false;
          } else if (
            this.circle.feeType == 1 &&
            (!this.circle.price || parseFloat(this.circle.price) < 0)
          ) {
            weui.alert("友情价必填且>=0");
            return false;
          } else if (this.circle.cost && parseInt(this.circle.cost) < 0) {
            weui.alert("原价必须>=0");
            return false;
          } else if (!this.circle.phone && !this.circle.wxNo) {
            weui.alert("请输入您的手机号码或微信号");
            return false;
          } else if (this.circle.phone && this.circle.phone.length != 11) {
            weui.alert("请输入正确手机号码");
            return false;
          } else {
            if (this.circle.feeType == 1) {
              this.resultDemand = "单价：￥" + this.circle.price;
            } else {
              this.circle.price = -1;
              this.resultDemand = "价格：免费";
              if (this.circle.demand) {
                this.resultDemand =
                  this.resultDemand + "，要求：" + this.circle.demand;
              }
            }
            return true;
          }
        }
      } else if (
        this.circle.bizType == 30 ||
        this.circle.bizType == 40 ||
        this.circle.bizType == 50 ||
        this.circle.bizType == 60
      ) {
        // 想租 // 出租 // 想借 // 出借
        if (this.circle.goodsType == -1) {
          weui.alert("请选择物品类别");
          return false;
        } else if (!this.circle.title) {
          weui.alert("请输入想租的物品");
          return false;
        } else if (!this.circle.sum) {
          weui.alert("请输入数量");
          return false;
        } else if (
          this.circle.feeType == 1 &&
          (!this.circle.price || parseFloat(this.circle.price) < 0)
        ) {
          weui.alert("友情价必填且>=0");
          return false;
        } else if (!this.circle.phone && !this.circle.wxNo) {
          weui.alert("请输入您的手机号码或微信号");
          return false;
        } else if (this.circle.phone && this.circle.phone.length != 11) {
          weui.alert("请输入正确手机号码");
          return false;
        } else {
          if (this.circle.feeType == 1) {
            this.resultDemand = "单价：￥" + this.circle.price;
          } else {
            this.circle.price = -1;
            this.resultDemand = "价格：免费";
            if (this.circle.demand) {
              this.resultDemand =
                this.resultDemand + "，要求：" + this.circle.demand;
            }
          }
          return true;
        }
      } else if (this.circle.bizType == 70) {
        // 我能
        if (!this.circle.title) {
          weui.alert("请输入您的技能");
          return false;
        } else if (
          this.circle.feeType == 1 &&
          (!this.circle.price || parseFloat(this.circle.price) < 0)
        ) {
          weui.alert("友情价必填且>=0");
          return false;
        } else if (
          this.circle.show == 1 &&
          (!this.circle.phone || this.circle.phone.length != 11)
        ) {
          weui.alert("请输入正确手机号码");
          return false;
        } else if (this.circle.show == 2 && !this.circle.wxNo) {
          weui.alert("请输入微信账号");
          return false;
        } else {
          if (this.circle.feeType == 1) {
            this.resultDemand = "单价：￥" + this.circle.price;
          } else {
            this.circle.price = -1;
            this.resultDemand = "价格：免费";
            if (this.circle.demand) {
              this.resultDemand =
                this.resultDemand + "，要求：" + this.circle.demand;
            }
          }
          return true;
        }
      }
    },
    gotoDetail() {
      this.$router.push(
        "/circleDetail/" + this.circle._id + "/" + this.encodeToken
      );
    },
  },
  beforeDestroy() {
    /* 重置微信分享 */
    let shareTitle =
      '本喵分享了最新动态，精彩校园生活尽在"校圆通"，快进来看看TAヾ(≧O≦)〃喵~'; // 分享标题
    let shareDesc = "专注校园生活，打造校园一站式综合服务平台。"; // 分享描述
    let shareLink = "http://wx.aixyt.com/#/share/home/-1";
    let shareLogo = "http://static.aixyt.com/logo.png";

    let msgShareContent = {
      title: shareTitle, // 分享标题
      desc: shareDesc, // 分享描述
      link: shareLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: shareLogo, // 分享图标
      success: () => {
        // 设置成功
      },
    };
    let tlShareContent = {
      title: shareTitle, // 分享标题
      link: shareLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: shareLogo, // 分享图标
      success: () => {
        // 设置成功
      },
    };
    let url = window.location.href;
    let params = {
      url: url,
    };
    let jsConfig = {};
    axios
      .get("/api/wx/jsconfig", { params })
      .then((res) => {
        jsConfig = res.data.data;
        jsConfig.jsApiList = [
          "updateAppMessageShareData",
          "updateTimelineShareData",
          "onMenuShareAppMessage",
          "onMenuShareTimeline",
        ];
        wx.config(jsConfig);
      })
      .catch((err) => {
        console.log(err);
      });

    wx.ready(function () {
      wx.updateAppMessageShareData(msgShareContent);
      wx.updateTimelineShareData(tlShareContent);
      wx.onMenuShareAppMessage(msgShareContent);
      wx.onMenuShareTimeline(tlShareContent);
    });
    /* 重置微信分享结束 */
  },
};
</script>

<style scoped>
.weui-cells_form .weui-cell__ft {
  font-size: 17px;
}
.title {
  margin-top: 10px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 10px;
  border-bottom: 1px solid #feb70f;
  position: relative;
}
.title i {
  position: absolute;
  left: 10px;
  font-size: 22px;
  color: #feb70f;
}
.title img {
  width: 18px;
  height: 18px;
  padding: 2px;
  border-radius: 50%;
  border: 2px solid #296aed;
}
.title div {
  font-size: 16px;
  font-weight: bold;
  margin-left: 5px;
  color: #6b6e77;
}
.pay {
  flex: 1;
  text-align: center;
  border-right: 1px solid #bdccd4;
}
.free {
  flex: 1;
  text-align: center;
}
.warehousing-footer-item {
  flex: 1;
  font-size: 18px;
  text-align: center;
  background-color: #feb70f;
  margin-top: 10px;
  line-height: 50px;
}
.warehousing-footer-item a {
  color: #ffffff;
}
.gou-selected {
  color: #feb70f;
}
.gou-unselect {
  color: #bdccd4;
}
.result-content {
  display: flex;
  justify-content: center;
  align-items: center;
}
.share-img {
  width: 300px;
}
#result {
  text-align: center;
  width: 300px;
  position: relative;
}
.logo {
  height: 20px;
  position: absolute;
  left: 15px;
  top: 20px;
  z-index: 10;
}
.result-cover {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 15px;
}
.result-title {
  display: flex;
  justify-content: center;
  align-items: center;
}
.result-title div {
  width: 270px;
  font-size: 16px;
}
.result-demand {
  display: flex;
  justify-content: center;
  align-items: center;
  color: red;
  font-size: 14px;
}
.result-qrcode {
  display: flex;
  justify-content: center;
  align-items: center;
}
.result-qr-tips {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 30px;
}
.text-error {
  color: red;
}
</style>




// WEBPACK FOOTER //
// src/components/operations/CircleEdit.vue